// Copyright (c) 2021 WiseTime. All rights reserved.

import { PostTimeGroup, PostTimeRequest, TimeGroup } from "../../generated/wisetime/user/timeline/v4/timeline_pb"
import { SiteRef } from "../../generated/wisetime/type/site_ref_pb"
import { TagRef } from "../../generated/wisetime/user/type/tag_ref_pb"
import { Duration } from "../../generated/google/protobuf/duration_pb"
import { hoursToSecondsRounded, secondsToHoursRounded } from "./timeGroups"
import { SelectedTimesheetFieldOption } from "../../generated/wisetime/user/type/selected_timesheet_field_option_pb"

export const roundedTotalDuration = (seconds: number, roundingPreferenceSeconds: number): number =>
  hoursToSecondsRounded(secondsToHoursRounded(seconds, roundingPreferenceSeconds).toString())

export const buildPostTimeRequest = (
  timeGroup: TimeGroup.AsObject,
  currentSiteRef: SiteRef.AsObject,
  roundingPreferenceSeconds: number,
): PostTimeRequest => {
  const request = new PostTimeRequest()
    .setSite(
      new SiteRef()
        .setId(currentSiteRef.id)
        .setDisplayName(currentSiteRef.displayName)
    )
    .setTimeGroupsList([
      new PostTimeGroup()
        .setTimeGroupId(timeGroup.id)
        .setTagsList(timeGroup.tagsList
          .filter(tag => tag.siteId === currentSiteRef.id)
          .map(tag => new TagRef().setId(tag.id).setSiteId(tag.siteId).setName(tag.name))
        )
        .setSelectedTimesheetFieldOptionsList(
          timeGroup.selectedTimesheetFieldOptionsList
            .filter(o => o.siteId === currentSiteRef.id)
            .map(o => new SelectedTimesheetFieldOption()
              .setSiteId(o.siteId)
              .setTimesheetFieldId(o.timesheetFieldId)
              .setTimesheetFieldOptionId(o.timesheetFieldOptionId)
            )
        )
        .setTotalDuration(
          new Duration()
            .setSeconds(timeGroup.totalDuration?.seconds ?? 0)
            .setNanos(timeGroup.totalDuration?.nanos ?? 0)
        )
        .setRoundedTotalDuration(
          new Duration().setSeconds(roundedTotalDuration(timeGroup.totalDuration?.seconds ?? 0, roundingPreferenceSeconds))
        )
    ])
  return request
}
